import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import OrganizationViewList from 'features/Organization';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function OrganizationViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="organization">
            <OrganizationViewList />
          </Can>
          <Can not do="read" on="organization">
            <h4 className="text-red-500">{t('permission.forbid.read.organizationList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default OrganizationViewListPage;
